import { AuthorizedRoutes } from './AuthorizedRoutes';
import { UnauthorizedRoutes } from './UnauthorizedRoutes';
import { selectors } from '@shared/store/ducks/auth';
import { useAppSelector } from '@shared/store';
import { AuthorizedSuperAdminRoutes } from './AuthorizedSuperAdminRoutes';
import { Navigate, useLocation } from 'react-router-dom';
import {
  SuperAdminAuthenticatedPath,
  SuperAdminUnauthenticatedPath,
  UnauthenticatedPath,
} from '@shared/constants/routes.constants';

export const Router = () => {
  const { pathname } = useLocation();

  const hasUserAuth = Boolean(useAppSelector(selectors.getAccessToken));
  const hasSuperAdminAuth = Boolean(useAppSelector(selectors.getSuperAdminAccessToken));

  const isSuperAdminArea = pathname.startsWith('/super-admin');

  const userUnauthAllowed = new Set<string>(['/', UnauthenticatedPath.SIGN_IN]).has(pathname);

  if (isSuperAdminArea) {
    if (hasSuperAdminAuth) return <AuthorizedSuperAdminRoutes />;
    return pathname === SuperAdminUnauthenticatedPath.SIGN_IN ? (
      <UnauthorizedRoutes />
    ) : (
      <Navigate to={SuperAdminUnauthenticatedPath.SIGN_IN} replace />
    );
  }

  if (hasUserAuth) return <AuthorizedRoutes />;
  if (!hasSuperAdminAuth) return <UnauthorizedRoutes />;

  return userUnauthAllowed ? (
    <UnauthorizedRoutes />
  ) : (
    <Navigate to={SuperAdminAuthenticatedPath.HOME_PAGE} replace />
  );
};
